import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";

type TabKey = "overview" | "features" | "pricing" | "faq";

export interface FourTabsProps {
  /** Which tab should be selected initially */
  defaultTab?: TabKey;
  /** Optional className to style the Tabs wrapper */
  className?: string;
  /** Get notified when the active tab changes */
  onChange?: (key: TabKey) => void;
}

export const ReactFourTabs_v01: React.FC<FourTabsProps> = ({
  defaultTab = "overview",
  className,
  onChange,
}) => {
  const [activeKey, setActiveKey] = useState<TabKey>(defaultTab);

  const handleSelect = (k: string | null) => {
    if (!k) return;
    const newKey = k as TabKey;
    setActiveKey(newKey);
    onChange?.(newKey);
  };

  return (
    <Tabs
      id="four-tabs-demo"
      className={className}
      activeKey={activeKey}
      onSelect={handleSelect}
      justify
      mountOnEnter
      unmountOnExit
    >
      <Tab eventKey="overview" title="Overview" tabClassName="fw-semibold">
        <div className="p-3">
          <h5 className="mb-2">Overview</h5>
          <p className="mb-0">
            Quick intro content goes here. Use this area for a high-level summary.
          </p>
        </div>
      </Tab>

      <Tab eventKey="features" title="Features" tabClassName="fw-semibold">
        <div className="p-3">
          <h5 className="mb-2">Key Features</h5>
          <ul className="mb-0">
            <li>Fast setup and easy customization</li>
            <li>Responsive design with react-bootstrap</li>
            <li>Type-safe tab keys</li>
          </ul>
        </div>
      </Tab>

      <Tab eventKey="pricing" title="Pricing" tabClassName="fw-semibold">
        <div className="p-3">
          <h5 className="mb-2">Pricing</h5>
          <p className="mb-1">Starter: $0 — basic features</p>
          <p className="mb-1">Pro: $19/mo — advanced tools</p>
          <p className="mb-0">Enterprise: Contact sales</p>
        </div>
      </Tab>

      <Tab eventKey="faq" title="FAQ" tabClassName="fw-semibold">
        <div className="p-3">
          <h5 className="mb-2">Frequently Asked Questions</h5>
          <p className="mb-1"><strong>Q:</strong> How do I style these tabs?</p>
          <p className="mb-3"><strong>A:</strong> Use Bootstrap utilities or custom CSS.</p>
          <p className="mb-1"><strong>Q:</strong> Can I control the active tab?</p>
          <p className="mb-0"><strong>A:</strong> Yes—use the <code>defaultTab</code> prop or manage state externally.</p>
        </div>
      </Tab>
    </Tabs>
  );
};

export default ReactFourTabs_v01;
